module.exports = __webpack_public_path__ + "static/media/CACII.6064679f.png";